import React from "react";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../contants/Endpoints";
import usePaginationState from "../../customHooks/usePaginationHook";
import { useSearchParams } from "react-router-dom";
const PurchaseStockComponent = loadable(
  () => import("../../components/PurchaseStock")
);

type Props = {};

const PurchaseStock = (props: Props) => {
  const { pageSize, setPageSize, offset, setOffset } = usePaginationState();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("search") || "";

  const { data: purchaseData, isPending: purchaseLoading } = useGetHook({
    queryKey: [`purchase-stock-${pageSize}-${offset}-${searchQuery}`],
    url: `${APIS.PURCHASE}`,
    params: {
      limit: pageSize,
      offset: offset,
      ...(searchQuery && { search: searchQuery }),
    },
  });
  return (
    <div>
      <PurchaseStockComponent
        purchaseData={purchaseData}
        purchaseLoading={purchaseLoading}
        pageSize={pageSize}
        setPageSize={setPageSize}
        offset={offset}
        setOffset={setOffset}
      />
    </div>
  );
};

export default PurchaseStock;
